export default "__VITE_ASSET__d8e48a7d__"